// Auto-generated at build time - do not edit
export const APP_VERSION = '1.0.4402';
